import React, { Component } from 'react'
import { Group, Panel, Separator } from 'react-resizable-panels'

/**
 * Drop-in replacement for the two-column grid layout used across tool views.
 *
 * Usage:
 *   <ResizablePanels storageKey="unique-tool-id">
 *     <div>...left...</div>
 *     <div>...right...</div>
 *   </ResizablePanels>
 *
 * On screens < 768 px the panels stack vertically (no handle).
 */
class ResizablePanels extends Component {
    constructor(props) {
        super(props)
        this.state = { isMobile: window.innerWidth < 768 }
        this.onWindowResize = this.onWindowResize.bind(this)
        this.onLayoutChanged = this.onLayoutChanged.bind(this)
    }

    componentDidMount() {
        window.addEventListener('resize', this.onWindowResize)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize)
    }

    onWindowResize() {
        const isMobile = window.innerWidth < 768
        if (isMobile !== this.state.isMobile) this.setState({ isMobile })
    }

    getSavedLayout() {
        const { storageKey, leftDefault = 50 } = this.props
        if (!storageKey) return undefined
        try {
            const raw = localStorage.getItem('rp:' + storageKey)
            if (raw) return JSON.parse(raw)
        } catch(e) {}
        return { left: leftDefault, right: 100 - leftDefault }
    }

    onLayoutChanged(layout) {
        const { storageKey } = this.props
        if (!storageKey) return
        try {
            localStorage.setItem('rp:' + storageKey, JSON.stringify(layout))
        } catch(e) {}
    }

    render() {
        const { leftMin = 20, rightMin = 20, leftDefault = 50, children } = this.props
        const [left, right] = React.Children.toArray(children)

        if (this.state.isMobile) {
            return (
                <div className="flex flex-col gap-3">
                    { left }
                    { right }
                </div>
            )
        }

        const defaultLayout = this.getSavedLayout()

        return (
            <Group
                orientation="horizontal"
                defaultLayout={ defaultLayout }
                onLayoutChanged={ this.onLayoutChanged }
                style={{ overflow: 'visible' }}
            >
                <Panel id="left" defaultSize={ leftDefault } minSize={ leftMin } style={{ overflow: 'visible' }}>
                    <div className="pr-1.5 h-full">{ left }</div>
                </Panel>

                <Separator className="group relative flex items-center justify-center w-3 shrink-0 cursor-col-resize select-none">
                    <div className="w-1 h-16 rounded-full bg-border group-hover:bg-primary/50 group-data-[separator=pointer]:bg-primary group-data-[separator=keyboard]:bg-primary transition-colors duration-150" />
                </Separator>

                <Panel id="right" defaultSize={ 100 - leftDefault } minSize={ rightMin } style={{ overflow: 'visible' }}>
                    <div className="pl-1.5 h-full">{ right }</div>
                </Panel>
            </Group>
        )
    }
}

export default ResizablePanels
